// extracted by mini-css-extract-plugin
export var cancelButton = "_nt-5";
export var content = "_nt-3";
export var createButton = "_nt-6";
export var drawerContainer = "_nt-0";
export var footer = "_nt-2";
export var header = "_nt-1";
export var orderFormColumn = "_nt-4";